import Vue from 'vue'
import VueRouter from 'vue-router'
import { isMobile } from '@/utils/device'
import { setPcRem, clearPcRem } from '@/utils/rem-pc'
import AdaptiveShell from '@/views/adaptive/AdaptiveShell.vue'
import HomeBridge from '@/views/adaptive/pages/HomeBridge.vue'
import TicketBridge from '@/views/adaptive/pages/TicketBridge.vue'
import StreamingBridge from '@/views/adaptive/pages/StreamingBridge.vue'
import AttentionBridge from '@/views/adaptive/pages/AttentionBridge.vue'
import GoodsBridge from '@/views/adaptive/pages/GoodsBridge.vue'
import contentVisibility from '@/views/data/content-visibility.json'

Vue.use(VueRouter)

/**
 * 首页（长页）切去子页时，先由 Layout 在过渡结束后再回顶，避免旧页先闪到顶部。
 */
function shouldDeferScrollReset(to, from) {
  return from.path === '/' && to.path !== '/'
}

const routes = [
  {
    path: '/',
    component: AdaptiveShell,
    meta: { showNav: true, showFooter: true },
    children: [
      {
        path: '',
        name: 'Home',
        component: HomeBridge,
        meta: { showNav: true, showFooter: true, showPcSidebar: true }
      },
      // 历史占位子路径：仍收敛到首页，避免开发阶段误跳 404
      { path: 'news', redirect: '/' },
      { path: 'about', redirect: '/' },
      { path: 'dj', redirect: '/' },
      {
        path: 'ticket',
        name: 'Ticket',
        component: TicketBridge,
        meta: { showNav: true, showFooter: true, showPcSidebar: true }
      },
      {
        path: 'streaming',
        name: 'Streaming',
        component: StreamingBridge,
        meta: { showNav: true, showFooter: true, showPcSidebar: true }
      },
      {
        path: 'attention',
        name: 'Attention',
        component: AttentionBridge,
        meta: { showNav: true, showFooter: true, showPcSidebar: true }
      },
      {
        path: 'goods',
        name: 'Goods',
        component: GoodsBridge,
        meta: { showNav: true, showFooter: true, showPcSidebar: true }
      },
      { path: 'goos', redirect: '/goods' }
    ]
  },
  /** 未注册路径 → 首页（与关闭 streaming/goods 时直链行为一致） */
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  /** 避免从首页滚到底后跳转其它路由仍停在底部；后退/前进保留原位置 */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    if (shouldDeferScrollReset(to, from)) {
      return false
    }
    return { x: 0, y: 0 }
  }
})

const headerVisibility = contentVisibility.header || {}

router.beforeEach((to, from, next) => {
  if (to.path === '/streaming' && headerVisibility.showStreamingNav === false) {
    return next({ path: '/', replace: true })
  }
  if (to.path === '/goods' && headerVisibility.showGoodsNav === false) {
    return next({ path: '/', replace: true })
  }
  next()
})

/** PC 路由：打标 + 同步 rem 根字号（见 rem-pc.js） */
function syncPcViewportLockClass() {
  const onPc = !isMobile()
  document.documentElement.classList.toggle('pc-viewport-lock', onPc)
  if (onPc) {
    setPcRem()
  } else {
    clearPcRem()
  }
}

router.afterEach(() => {
  syncPcViewportLockClass()
})

syncPcViewportLockClass()

export default router
